<template>
  <CSectionCard v-if="items.length > 0" :title="job.getTitle()">
    <CJobPart v-for="item in items" :item :context v-model="formData"/>
  </CSectionCard>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import CSectionCard from '@/shared/components/section/CSectionCard.vue';
  import Job from '../../models/Job';
  import JobContext from '../../models/JobContext';
  import CJobPart from './CJobPart.vue';

  const props = defineProps<{
    job: Job;
    context: JobContext;
  }>();

  const formData = defineModel();

  const items = computed(() => props.context.getActivePartItems().filter(i => i.jobId === props.job.id));
</script>